<h1 mat-dialog-title i18n>Bike Information</h1>

<app-info-section [header]="'Basic Details'" [details]="bikeDetails"></app-info-section>

<div *ngIf="bike && bike['isRegistered']">
	<div class="row mr-4" *ngIf="dataReady && !bikeHasActiveTransferRequests">
		<div class="col-12 text-right mb-4 mt-2">
			<button
				type="button"
				mat-flat-button
				color="warn"
				i18n
				(click)="transferBike()"
				title="Close"
				i18n-title
				class="float-right mr-sm-2 col-12 col-sm-auto reset-button"
			>Begin a Transfer Request</button>
		</div>
	</div>

	<div class="registration-details">
		<app-info-section [header]="'Registration Details'" [details]="registrationDetails"></app-info-section>
	</div>

<!-- TODO: We don't allow deleting a registration for now	
	<div class="row mr-4">
		<div class="col-12 text-right mb-4 mt-2">
			<button
				*ngIf="bike['isRegistered']"
				type="button"
				mat-flat-button
				color="warn"
				i18n
				(click)="deleteCurrentRegistration()"
				title="Close"
				i18n-title
				class="float-right mr-sm-2 col-12 col-sm-auto reset-button"
			>Delete Current Registration</button>
		</div>
	</div> -->
</div>

<div *ngIf="bike && !bike['isRegistered']">
	<h1 mat-dialog-title i18n>Register the Bike</h1>
	<p class="description">Register a bike using this form. ONLY do this if the user is unable to register it in any other way. This requires that the given email address be a valid user in the Specialized system.</p>

	<div class="section-details">
		<label class="col-4" i18n>Email</label>
		<input class="col-4" type="text"/>
	</div>

	<div class="section-details">
		<label class="col-4" i18n>Purchase Date</label>
		<input class="col-4" type="text" value="dd/mm/yyyy"/>
	</div>

	<div class="row mr-4">
		<div class="col-12 text-right mb-4 mt-2">
			<button
				type="button"
				mat-flat-button
				color="warn"
				i18n
				(click)="registerBike()"
				title="Close"
				i18n-title
				class="float-right mr-sm-2 col-12 col-sm-auto reset-button"
			>Register Bike</button>
		</div>
	</div>
</div>

<app-view-transfer-history *ngIf="dataReady" [header]="'Transfer History'" [transferHistory]="transferHistory"></app-view-transfer-history>
